import React, { useState } from 'react'
import { Box, IconButton, Tooltip, Typography, Grid, Divider } from '@mui/material'

import { Button } from '@/@core/components/mui/Button'
import { FilterButton } from '../../common'
import { TableLimit } from '@/@core/components/mui/TableLimit'
import CompanySelection from '../../selection/CompanySelection'
import UserStatusSelection from '../../selection/UserStatusSelection'
import { useRouteQuery, useTranslator } from '@/hooks'
import { SearchInput } from '../../common/SearchInput'
import InputDateRangerField from '../../common/input/InputDateRangerField'
import RoleSelection from '../../selection/RoleSelection'
// import { useNavigate } from 'react-router-dom'

interface UserTableFilterProps {
  onSearch?: (value: string) => void
  onAddEmployee?: () => void
  onOpenLogs?: () => void
}

export const UserTableFilter: React.FC<UserTableFilterProps> = ({ onAddEmployee, onOpenLogs }) => {
  const { __ } = useTranslator()
  const { updateQuery, searchQuery } = useRouteQuery()
  const [filter, setFilter] = useState(true)
  // const navigate = useNavigate()

  return (
    <Box
      sx={{
        display: 'flex',
        padding: '20px',
        gap: 4,
        flexDirection: 'column'
      }}
    >
      {filter && (
        <>
          <Box className='mb-3'>
            <Typography variant='h6' className='mb-3'>
              {__('Filters')}
            </Typography>
            <Grid container spacing={4}>
              <Grid size={3}>
                <CompanySelection
                  value={searchQuery.get('company_id') || ''}
                  onChange={company_id => {
                    updateQuery({ company_id, page: 1 })
                  }}
                  onClear={() => {
                    updateQuery({ company_id: undefined })
                  }}
                />
              </Grid>
              <Grid size={3}>
                <RoleSelection
                  value={searchQuery.get('role_id') || ''}
                  placeholder={__('Select Role')}
                  onChange={role => {
                    updateQuery({ role_id: role, page: 1 })
                  }}
                  onClear={() => {
                    updateQuery({ role_id: undefined })
                  }}
                />
              </Grid>
              <Grid size={3}>
                <InputDateRangerField
                  value={
                    searchQuery.get('created_from')
                      ? [searchQuery.get('created_from') as string, searchQuery.get('created_to') as string]
                      : []
                  }
                  onChange={created_at => {
                    if (created_at) {
                      updateQuery({ created_from: created_at[0], created_to: created_at[1], page: 1 })
                    } else {
                      updateQuery({ created_from: undefined, created_to: undefined })
                    }
                  }}
                />
              </Grid>
              <Grid size={3}>
                <UserStatusSelection
                  value={searchQuery.get('status') || ''}
                  onSelect={status => {
                    updateQuery({ status, page: 1 })
                  }}
                  excludeGuestStatuses={true}
                />
              </Grid>
            </Grid>
          </Box>
          <Divider />
        </>
      )}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <TableLimit />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <SearchInput
            placeholder={__('Search User')}
            onSearch={value => {
              updateQuery({ keywords: value })
            }}
            initialValue={searchQuery.get('keywords') || ''}
          />

          <FilterButton filter={filter} onFilter={() => setFilter(!filter)} />

          <Tooltip title={__('Add New User')}>
            <Button
              variant='contained'
              size='small'
              onClick={onAddEmployee}
              startIcon={<i className='tabler-plus' />}
              sx={{ height: 40 }}
            >
              {__('Add New User')}
            </Button>
          </Tooltip>

          <Tooltip title='History'>
            <IconButton
              size='small'
              onClick={onOpenLogs}
              sx={{
                width: 40,
                height: 40,
                backgroundColor: '#2E263D14',
                '&:hover': {
                  backgroundColor: '#e0e0e0'
                }
              }}
            >
              <i className='tabler-history' style={{ fontSize: 18 }} />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </Box>
  )
}
